import {ApplicationConfig, isDevMode, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {ConfirmationService, MessageService} from 'primeng/api';
import {provideHttpClient} from '@angular/common/http';
import {provideTransloco} from '@jsverse/transloco';
import {TranslocoHttpLoader} from './transloco-loader';
import {CodaCleanTheme} from './mytheme';
import {DialogService} from 'primeng/dynamicdialog';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(),
    provideTransloco({
      config: {
        availableLangs: ['en', 'nl', 'fr'],
        defaultLang: 'fr',
        reRenderOnLangChange: true,
        prodMode: false
      },
      loader: TranslocoHttpLoader
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: CodaCleanTheme,
        options: {
          darkModeSelector: false,
          cssLayer: false,
        }
      }
    }),
    MessageService,
    ConfirmationService,
    DialogService,
    provideHttpClient(), provideTransloco({
      config: {
        availableLangs: ['en', 'fr', 'nl'],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    })
  ]
};
